import { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { games, categories } from '@/mocks/games';

export default function HotGamesSection() {
  const [activeTab, setActiveTab] = useState('all');

  const displayCategories = [{ slug: 'all', name: '全部' }, ...categories];

  const filteredGames = useMemo(() => {
    if (activeTab === 'all') return games.filter((g) => g.isHot || g.isNew);
    return games.filter((g) => g.categorySlug === activeTab);
  }, [activeTab]);

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            <a href="#hot-games">热门推荐</a>
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            精选人气游戏，千万玩家的共同选择
          </p>
        </div>

        <div className="flex items-center justify-center gap-1.5 mb-10 flex-wrap px-1 py-1 bg-background-200/50 rounded-full max-w-3xl mx-auto">
          {displayCategories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => setActiveTab(cat.slug)}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all ${
                activeTab === cat.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {filteredGames.map((game) => (
            <Link
              key={game.id}
              to={`/category/${game.categorySlug}`}
              className="group bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden cursor-pointer hover:-translate-y-1 transition-all duration-300"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={game.image}
                  alt={game.name}
                  title={`九游娱乐${game.name}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {game.tag && (
                  <span className={`absolute top-3 left-3 px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                    game.tag === '热门' || game.tag === '爆款'
                      ? 'bg-accent-500 text-background-50'
                      : game.tag === '新品'
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-secondary-500 text-background-50'
                  }`}>
                    {game.tag}
                  </span>
                )}
              </div>
              <div className="p-4">
                <h3 className="text-base font-medium text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {game.name}
                </h3>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-1">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-primary-500 text-xs"></i>
                    </div>
                    <span className="text-sm text-foreground-700">{game.rating}</span>
                  </div>
                  <span className="text-xs text-foreground-500">
                    <i className="ri-user-line mr-1"></i>
                    {game.players}玩家
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}